import React, { useMemo, useRef } from "react";
import { Editor } from "@tinymce/tinymce-react";

export default function TinyMCEFullEditor({
  value = "",
  onChange,
  height = 320,
  placeholder = "",
}) {
  const editorRef = useRef(null);

  const init = useMemo(
    () => ({
      license_key: "gpl",
      height,
      menubar: false,
      branding: false,

      plugins: [
        "lists",
        "link",
        "image",
        "table",
        "code",
        "preview",
        "searchreplace",
        "visualblocks",
        "wordcount",
        "charmap",
        "anchor",
        "autolink",
        "fullscreen",
      ],

      toolbar:
        "undo redo | blocks | fontfamily fontsize | " +
        "bold italic underline strikethrough | forecolor backcolor | " +
        "alignleft aligncenter alignright alignjustify | " +
        "bullist numlist outdent indent | " +
        "link image | table | removeformat | code fullscreen",

      table_toolbar:
        "tableprops tabledelete | tableinsertrowbefore tableinsertrowafter tabledeleterow | " +
        "tableinsertcolbefore tableinsertcolafter tabledeletecol | " +
        "tablemergecells tablesplitcells",

      font_family_formats:
        "Helvetica=helvetica,arial,sans-serif;Arial=arial,helvetica,sans-serif;Poppins=Poppins,sans-serif;",
      font_size_formats: "10px 12px 14px 16px 18px 20px 24px 28px 32px",

      // ✅ Default font size to 12px
      fontsize_default: "12px",
      content_style:
        "body { font-size: 12px; font-family: Poppins, Arial, Helvetica, sans-serif; }",

      placeholder: placeholder || "",
    }),
    [height, placeholder]
  );

  return (
    <div style={{ borderRadius: 10, overflow: "hidden" }}>
      <Editor
        tinymceScriptSrc="/tinymce/tinymce.min.js"
        value={value}
        onInit={(evt, editor) => {
          try {
            editorRef.current = editor;
          } catch (e) {
            console.error(e);
          }
        }}
        onEditorChange={(newValue) => {
          try {
            onChange?.(newValue);
          } catch (e) {
            console.error(e);
          }
        }}
        init={init}
      />
    </div>
  );
}
